import APIClient from '@/shared/http/clients/api'

const resourceName = 'parametros/gera-card-matricula'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)

const ParametroGeracaoCardContaCapitalRepository = {
  GetAll,
  Create,
  Update
}

export default ParametroGeracaoCardContaCapitalRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/parametroGeracaoCardContaCapital.js